module.exports = __webpack_public_path__ + "static/media/add-icon.2a15f7ac.svg";